import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * Bridges BulkPerk's legacy `cart:add` / `cart:refresh` events to the theme's
 * CartLinesUpdateEvent, so the cart drawer, cart page and cart bubble re-render
 * after the app adds a product (e.g. from the cart drawer upsells).
 */

const DEBOUNCE_MS = 50;

/** @type {ReturnType<typeof setTimeout> | undefined} */
let timer;
/** @type {string | undefined} */
let pendingVariantId;

/** @param {Event} event */
function onLegacyCartEvent(event) {
  const detail = /** @type {CustomEvent} */ (event).detail;
  if (detail?.variantId) pendingVariantId = String(detail.variantId);

  // BulkPerk fires cart:refresh and cart:add back to back — collapse them into one update.
  clearTimeout(timer);
  timer = setTimeout(dispatchCartUpdate, DEBOUNCE_MS);
}

function dispatchCartUpdate() {
  const variantId = pendingVariantId;
  pendingVariantId = undefined;

  const deferred = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: variantId ? 'add' : 'update',
      context: 'cart',
      lines: variantId ? [{ merchandiseId: variantId, quantity: 1 }] : [],
      promise: deferred.promise,
    })
  );

  fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
    .then((response) => response.json())
    .then((ajaxCart) =>
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: {
          items: ajaxCart.items,
          itemCount: ajaxCart.item_count,
          source: 'bulkperk-cart-bridge',
          didError: false,
        },
      })
    )
    .catch(deferred.reject);
}

document.addEventListener('cart:add', onLegacyCartEvent);
document.addEventListener('cart:refresh', onLegacyCartEvent);
